export class PerfilamientoMasterRespuestasPadre {
  idRespuestaPadre: number;
  descripcionRespuesta: string;
  idPregunta: number;
  tipoCancelacionPadre: number;
  respuestaBenchMark: number;
  idUsuarioUM: number;
  fechaHoraUM: string;
  seleccion:boolean = false;
}
